(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dinghy', {
            parent: 'entity',
            url: '/dinghy?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy/dinghies.html',
                    controller: 'DinghyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dinghy-detail', {
            parent: 'dinghy',
            url: '/dinghy/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.dinghy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dinghy/dinghy-detail.html',
                    controller: 'DinghyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dinghy', function($stateParams, Dinghy) {
                    return Dinghy.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dinghy',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dinghy-detail.edit', {
            parent: 'dinghy-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy.new', {
            parent: 'dinghy',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                comment: null,
                                available: false,
                                type: null,
                                active: false,
                                dateDeactivated: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('dinghy');
                });
            }]
        })
        .state('dinghy.edit', {
            parent: 'dinghy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-dialog.html',
                    controller: 'DinghyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dinghy.delete', {
            parent: 'dinghy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dinghy/dinghy-delete-dialog.html',
                    controller: 'DinghyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dinghy', function(Dinghy) {
                            return Dinghy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dinghy', null, { reload: 'dinghy' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
